import styled from "styled-components";

export const Wrapper = styled.div`
    .lead-status-container {
        /* background-color: red; */
        border: 1px solid lightgray;
        border-radius: 8px;
    }
    /* #btn-end{
    background: #3a96b8;
    font-size: 16px;
    color: white;
    border: 0 none;
    border-radius: 3px;
    cursor: pointer;
    border: 2px solid transparent;
    width: 100%;
    padding-bottom: 35px;
    padding-top: 12px;
  } */
    .lead-form-row {
        padding: 20px 0px 0px 20px;
    }
    .label-conatiner {
        font-size: 15px;
        font-weight: bold;
    }
    .text-conatiner {
        font-size: 15px;
        margin: 0px;
        width: 100%;
    }

    .status-rescheduled-container {
        border: 1px solid lightgray;
        border-radius: 8px;
    }
    .status-rescheduled-row {
        padding: 20px;
    }
    .rescheduled-row {
        display: flex;
        flex-direction: column;
    }
    .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
        height: 40px;
    }
    .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
    .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
        margin-top: 5px;
    }
    .admin-button-col {
        margin-top: 20px;
        /* padding-bottom: 67px; */
    }
    .button-edit {
        cursor: pointer;
        margin-left: 10px;
        // margin-top: -7px;
        // background-color: #fff;
        // svg {
        //   fill: black;
        // }
    }

    
    .edit-cross-tick {
        display: flex;
        /* background-color: red; */
        align-items: center;
        justify-content: space-between;
        svg {
            background-color: #3a96b8;
            border-radius: 20px;
            font-size: 22px;
            fill: #fff;
        }

        .deKOJF {
            background-color: #fff;
            display: flex;
            align-items: center;
            height: 23px;
            padding: 0px;
            width: 23px;
        }
    }
    .utility-bill {
        text-decoration: underline;
    }
    .notification-button-col {
        margin-top: -10px !important;
    }
    .notification-button-col {
        /* .Tabs-container {
      width: 475px !important  ;
    } */
    }
    .notification-button-col {
        margin-top: 10px;
        height: 170px;
    }
    .ant-tabs-content-holder {
        /* width: 100%; */
        height: 150px;
        overflow-y: scroll;
        overflow-x: hidden;
        ::-webkit-scrollbar {
            width: 10px;
        }
        ::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px grey;
            border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
            background: #3a96b8;
            border-radius: 10px;
        }
    }
    .ant-tabs-nav .ant-tabs-tab:nth-child(2) {
        margin-left: 0px !important;
    }
    .ant-tabs-nav .ant-tabs-tab {
        border-radius: 0px !important;
        font-size: 20px !important;
    }
    .ant-tabs-nav {
        margin: 0px !important;
    }
    .ant-tabs-content-holder {
        border-width: 1px;
        border-color: #f0f0f0;
        border-style: solid;
        border-top-style: none;
    }
    .msg-card {
        margin: 4px 5px;
        background: #fafafa;
        display: flex;
        justify-content: space-between;
        padding: 5px 10px;
    }
    .avatar {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        margin-top: 4px;
        margin-right: 10px;
    }
    .notification-header-col {
        display: flex;
        align-items: center;
        h6 {
            font-size: 20px;
            margin-top: 10px;
        }
    }
    .message-col {
        margin-top: 10px;
    }
    .message {
        border: 2px solid #dddddd;
        font-size: 15px;
    }
    input {
        ::placeholder {
            font-size: 15px !important;
        }
    }
    .ant-select-selector {
        border: 1px solid #dddddd !important;
        height: 40px !important;
    }
    .ant-select-selection-item,
    .ant-select-selection-search {
        padding-top: 5px;
    }
    .phone-anchor {
        display: flex;
        align-items: baseline;
        svg {
            margin-right: 7px;
            margin-top: -2px;

            font-size: 15px;
        }
    }
    .home-container {
        display: flex;
        align-items: baseline;
        svg {
            margin-right: 7px;
            margin-top: -1px;
            font-size: 15px;
        }
    }
    .proposal-button-col {
        margin-bottom: 15px;
    }
    .proposal-link-col {
        a {
            display: flex;
            justify-content: center;
        }
    }

    /* .Pay-history-column-container {
    padding-left: 20px !important;
    h5 {
      margin: 0px;
    }
  }

  .collapse-ruppee-header {
    font-size: 17px;
    font-weight: bold;
    color: white;
  }
  .collapse-date-header {
    font-size: 15px;
    font-weight: 550;
    color: white;
  }
  .sub-collapse-row {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .sub-collapse-name {
    padding-left: 11px;
    p {
      margin: 0px;
    }
  }
  .sub-collapse-ruppee {
    display: flex;
    justify-content: center;
    p {
      margin: 0px;
    }
  }
  .sub-collapse-description {
    display: flex;
    justify-content: flex-end;
    padding-right: 11px;
    p {
      margin: 0px;
    }
  }
  .graph-column-container {
    padding-bottom: 50px;
    border-bottom: 2px solid #e7d8d8;
    border-radius: 5px;
  } */
`;

export const LeadUpgradeWrapper = styled.div`
    .ant-form-item {
        margin-bottom: 10px;
    }
    .details-col {
        /* width: 100%; */
    }
    #info-notes {
        white-space: nowrap;
        width: 80%;
        overflow: auto;
    }
    #info-notes::-webkit-scrollbar {
        display: none;
    }
    .text-information {
        color: white;
    }
    .main-border-column {
        border-bottom: 1px solid #dddddd;
        padding-bottom: 10px;
    }
    .main-border-column1 {
        background-color: white;
        label {
            font-weight: 600;
        }
    }
    .main-content-row {
        align-items: center;
        
        height: 40px;
        /* width: 100%; */
        display: flex;
        justify-content: space-between;
    }
    .text-conatiner {
        font-size: 14px;
        margin: 0px;
        width: 100%;
    }
    .lead-header {
        /* background: #001529;
    padding: 5px;
    border-radius: 2px; */
    }
    .man-avatars {
        width: 50px;
      height: 50px;
        color: #fff;
        font-size: 25px;
        margin-left: 10px;
        // margin-top: -10px;
        vertical-align: baseline;
    }
    .man-avatar {
        /* width: 50px;
    height: 50px; */
        color: #fff;
        font-size: 35px;
        margin-left: 10px;
        margin-top: -10px;
        vertical-align: baseline;
        /* img {
      width: 50px;
      height: 50px;
    } */
    }
    .lead-info {
        display: flex;
        align-items: center;
        background: linear-gradient(to right, #131f28, #131f28);

        /* padding: 5px; */
        border-radius: 10px;
    }
    .lead-name {
        width: 100%;
        margin-left: 10px;
        margin-top: 10px;
        label {
            color: #fff;
        }
        h6 {
            color: #fff;
        }
    }
    .lead-info-container {
        border: 1px solid #dddddd;
        // margin-top: 10px;
        .ant-typography {
            width: 100%;
            display: flex;
            justify-content: space-between;
            border-bottom: 1px solid #dddddd;
            align-items: center;
            // padding: 5px 0px;
        }

        .anticon .anticon-edit {
            color: #dddbda;
        }
        label {
            display: flex;
            align-items: center;
            font-weight: 600;
        }
        svg {
            color: #615e5e;
        }
    }

    .ant-collapse > .ant-collapse-item > .ant-collapse-header {
        /* background: #dddddd2c; */
        background: linear-gradient(to right, #131f28, #131f28);
        display: flex;
        align-items: center;
        padding: 10px 15px;
        color: white;
        height: 45px;
    }
    .ant-collapse-expand-icon {
        display: flex;
    }
    .address-info {
        label {
            display: flex;
            font-weight: 600;
        }
    }
    .address {
        /* border-bottom: 1px solid #dddddd; */
        display: flex;
        justify-content: space-between;
        svg {
            color: #615e5e;
        }
    }

    /* Edit view css below */

    .edit-inputs {
        height: 40px;
        border: 1px solid #dddddd;
        font-size: 14px;
    }
    .utilPic {
        height: 93px;
        border: 1px solid red;
    }
    .edit-details-col {
        padding-right: 20px;
        padding-top: 10px;

        .upload-Btn {
            svg {
                fill: white !important;
            }
        }
    }
    .edit-details-collaspe-col {
        padding-left: 10px;
    }
    .ant-select-selector {
        border: 1px solid #dddddd !important;
        height: 40px !important;
    }
    .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
    .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
        margin-top: 5px;
    }
    .ant-select-selection-item,
    .ant-select-selection-search {
        padding-top: 5px;
    }
    .edit-collaspe-label {
        padding-bottom: 5px;
    }

    /* Notification css below */
    .notification-collapse {
        border: 1px solid lightgray;
        border-radius: 8px;
        padding: 5px 15px;
    }
    .notification-collaspe {
        .ant-collapse-header {
            padding: 6px 15px !important;
        }
        .ant-select-selector {
            height: 35px !important;
        }
        .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
        .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
            margin-top: 1px;
        }
        .ant-select-selection-item,
        .ant-select-selection-search {
            padding-top: 1px;
        }
    }
    .status-rescheduled-row {
        display: flex;
        align-items: center;
        padding: 0px !important;
        h6 {
            margin: 0px;
        }
    }
    .rescheduled-row {
        display: flex;
        flex-direction: column;
    }
    .notification-header-col {
        display: flex;
        align-items: center;
        h6 {
            font-size: 17px;
            margin-top: 10px;
            color: #fff;
            margin: 0px;
        }
    }
    .message-col {
        margin-top: 10px;
    }
    .message {
        border: 2px solid #dddddd;
        font-size: 15px;
    }
    input {
        ::placeholder {
            font-size: 15px !important;
        }
    }
    .notification-button-col {
        margin-top: -10px !important;
    }

    .notification-button-col {
        margin-top: 10px;
        height: 170px;
    }
    .ant-tabs-content-holder {
        /* width: 100%; */
        height: 150px;
        overflow-y: scroll;
        overflow-x: hidden;
        ::-webkit-scrollbar {
            width: 10px;
        }
        ::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px grey;
            border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
            background: #3a96b8;
            border-radius: 10px;
        }
    }
    .ant-tabs-nav .ant-tabs-tab:nth-child(2) {
        margin-left: 0px !important;
    }
    .ant-tabs-nav .ant-tabs-tab {
        border-radius: 0px !important;
        font-size: 20px !important;
    }
    .ant-tabs-nav {
        margin: 0px !important;
    }
    .ant-tabs-content-holder {
        border-width: 1px;
        border-color: #f0f0f0;
        border-style: solid;
        border-top-style: none;
    }
    .msg-card {
        margin: 4px 5px;
        background: #fafafa;
        display: flex;
        justify-content: space-between;
        padding: 5px 10px;
    }
    .avatar {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        margin-top: 4px;
        margin-right: 10px;
    }
    .left-container {
        border: 1px solid #dddddd;
        border-radius: 10px;
        position: relative;
        left: -5px;
        background-color: white;
    }
    /* .right-container {
    position: relative;
    left: 5px;
  } */
    .proposal-button-col {
        margin-bottom: 15px;
    }
    .proposal-link-col {
        display: flex;
        /* justify-content: center; */
        color: blue;
        font-weight: bold;
    }
    .ant-select-selector {
        /* margin-left: 25px; */
    }

    .lead-info-main-head-project {
    }
    .Lead-info-proposal {
        h5 {
            color: #fff;
            padding-top: 10px;
        }
    }
    .Lead-info-main-head {
        /* background: linear-gradient(to right, #34b3f2, #000203b3); */
        background: linear-gradient(to right, #000000, #131f28);
        /* height: 50px; */
        /* border-bottom: 1px solid #dddddd; */
        h5 {
            padding-top: 10px;
            color: #fff;
        }
    }
    .Proposal {
        svg {
            fill: #ffff;
        }
    }

    .lead-bg {
        background-image: url("https://i.ibb.co/yV09fWC/Top-Image.jpg");
        height: 25vh;
        width: 100vw;
        background-repeat: no-repeat;
        background-size: 100% 130%;
        opacity: 0.6;
        object-fit: cover;
    }
    .form {
        background: #fff;
        height: 100%;
        position: relative;
        bottom: 40px;
        border-radius: 60px;
    }
    @media screen and (max-width: 1000px) {
        .left-container {
            position: relative;
            left: 0px;
        }
        .right-container {
            position: relative;
            left: 0px;
        }
        .notification-collaspe {
            .ant-select-single.ant-select-show-arrow .ant-select-selection-item,
            .ant-select-single.ant-select-show-arrow .ant-select-selection-placeholder {
                margin-top: 0px;
            }
            .ant-select-selection-item,
            .ant-select-selection-search {
                padding-top: 0px;
            }
        }
    }
`;

export const LeadDetailsSmallScreenWrapper = styled.div`
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    position: relative;

    .top-bg-image {
        height: 250px;
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        background-attachment: fixed;
        background-position: inherit;
        background-size: contain;
        position: relative;
    }
    .mapViews {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 15px;
        position: absolute;
        top: 10px;
        left: 20px;
    }
    .leads-details-container {
        position: relative;
        background: white;
        margin-top: -20px;
        padding-bottom: 60px;
        border-top-right-radius: 25px;
        border-top-left-radius: 25px;
    }
    .top-header-lead-name {
        position: absolute;
        top: -10px;
        width: 100%;
        text-align: center;
    }
    .top-header-lead-name .top-header-lead-name-textbox {
        background: #000000;
        color: white;
        font-size: 16px;
        font-weight: 600;
        border-radius: 5px;
        padding: 5px 10px;
        text-align: center;
        letter-spacing: 2px;
    }
    .leads-details-body {
        height: 100%;
        padding: 15px;
    }
    .leads-details-body-field {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        padding: 15px 10px;
        border-bottom: 1px solid lightgray;
    }
    .leads-details-body-field-key {
        font-size: 14px;
        font-weight: bolder;
        text-transform: capitalize;
        width: 110px
    }
    .leads-details-body-field-value {
        font-size: 14px;
    }
    .lead-body-expansion {
        margin-top: 25px;
        display: flex;
        flex: 1;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }
    .lead-body-expansion-header {
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        align-items: center;
        font-size: 14px;
        font-weight: 600;
        color: white;
        background: #131f28;
        padding: 10px 8px;
        border-radius: 3px;
    }
    .lead-body-expansion-body {
        width: 100%;
        padding: 5px 8px;
        box-shadow: 0px 2px 4px #b5b1b1;
    }
    .lead-details-floating-button {
        height: 40px;
        width: 40px;
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .top-bg-icons {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 20px;
        gap: 8px;   
        margin-right: 10px;
    }

    .solo-proposal-btn-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;

        .solo-prop-btn-container {
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .disabled {
                background: #cccccc !important;
                color: #666666 !important;
                pointer-events: none;
                border: 1px solid #2e2e2e !important;
            }
            .main-btn {
                border: none;
                background: #131f28;
                color: white;
                font-size: 16px;
                font-weight: 600;
                width: 100px;
                padding: 5px;   
                border-radius: 5px;
            }
            .link-btn {
                background: #3995b7;
                border: none;
                width: 30px;
                color: white;
                font-size: 16px;
                padding: 5px;
                margin-left: -2px;
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
            }
        }
    }

`;